<template>
    <h1>
        Componente 2
    </h1>
</template>